import { useState } from "react";
import { usePostHogTracking } from "@/hooks/usePostHogTracking";

type ClaimBannerProps = {
  storeSlug: string;
  onDismiss: () => void;
};

export default function ClaimBanner({ storeSlug, onDismiss }: ClaimBannerProps) {
  const [dismissing, setDismissing] = useState(false);
  const { trackClaim } = usePostHogTracking();

  const handleDismiss = () => {
    trackClaim.bannerDismissed({ store_slug: storeSlug });
    setDismissing(true);
    // Small delay so the CSS transition plays before parent unmounts
    setTimeout(onDismiss, 230);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        background: "transparent",
        border: "1px dashed var(--ys-rule-2)",
        borderRadius: "var(--ys-r)",
        padding: "9px 14px",
        direction: "rtl",
        opacity: dismissing ? 0 : 1,
        transform: dismissing ? "translateY(-4px)" : "translateY(0)",
        transition: "opacity 220ms var(--ys-ease), transform 220ms var(--ys-ease)",
      }}
    >
      {/* Shield icon */}
      <svg
        width={22}
        height={22}
        viewBox="0 0 24 24"
        fill="none"
        stroke="var(--ys-ink-3)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flexShrink: 0 }}
        aria-hidden="true"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>

      {/* Text */}
      <span
        style={{
          fontFamily: "var(--ys-font)",
          fontSize: 13,
          color: "var(--ys-ink-2)",
          flex: 1,
          lineHeight: 1.5,
        }}
      >
        هل هذا متجرك؟ طالب به للرد على التقييمات وتحديث البيانات.{" "}
        <a
          href={
            storeSlug
              ? `/claim?store=${encodeURIComponent(storeSlug)}`
              : "/claim"
          }
          onClick={() => trackClaim.bannerClicked({ store_slug: storeSlug })}
          style={{
            color: "var(--ys-primary)",
            textDecoration: "underline",
            fontWeight: 500,
          }}
        >
          طالب بالمتجر ↗
        </a>
      </span>

      {/* Dismiss button */}
      <button
        onClick={handleDismiss}
        aria-label="إغلاق"
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "var(--ys-ink-3)",
          fontFamily: "var(--ys-font)",
          fontSize: 18,
          lineHeight: 1,
          padding: "2px 4px",
          flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}
